<h2>{{ 'BOOKINGS.SELECT_SERVICE' | translate }}</h2>
<mat-accordion>
  <ng-container *ngFor="let serviceCategory of serviceCategories">
    <ng-container
      *ngIf="serviceCategory.getBookableServiceDefinitions().length > 0"
    >
      <mat-expansion-panel
        class="smc-service-category-panel"
        [expanded]="serviceCategories.length === 1"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ serviceCategory.categoryName }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-nav-list>
          <ng-container
            *ngFor="let serviceDefinition of serviceCategory.getBookableServiceDefinitions()"
          >
            <mat-list-item
              class="smc-service-list-item"
              (click)="serviceSelect(serviceDefinition)"
            >
              <h2
                class="smc-clickable-text smc-service-name"
                tappable
                mat-line
              >
                {{ serviceDefinition.serviceName }}
              </h2>
              <span
                mat-line
                class="smc-service-description"
                *ngIf="serviceDefinition.getDescription() !== 'undefined' && serviceDefinition.getDescription() !== '' && serviceDefinition.getDescription() !== ' ' && serviceDefinition.getDescription() !== null"
                [innerHtml]="serviceDefinition.getDescription() | safe : 'html'"
              ></span>
              <p mat-line class="smc-service-details">
                {{ 'BOOKINGS.STARTING_AT' | translate }}
                {{ (serviceDefinition.getPrice() | salonMonsterCurrency) + ", " }}
                {{ 'BOOKINGS.ABOUT' | translate }} {{ serviceDefinition.getDuration() +
                      serviceDefinition.getProcessDuration() +
                      serviceDefinition.getFinishDuration()
                      | SalonMonsterFormatDurationPipe }}
              </p>
            </mat-list-item>
          </ng-container>
        </mat-nav-list>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>
</mat-accordion>
